import * as Styled from './full-modal.styled'
import {Icon} from '../media/icons/Icon'
import {CloseButton} from '../button/close-button/close-button'
import {Modal} from '../base/modal/modal'
interface ModalProps {
    label: string
    isOpen: boolean
    onClose?: () => void
    title?: string
    icon?: string
    children: React.ReactNode
    footer?: React.ReactNode
    showCloseButton?: boolean
    size?: 'sm' | 'lg' | 'md' | 'xl'
    alt?: string
    badge?: React.ReactNode
}

export function FullModal({
    label,
    isOpen,
    onClose,
    title,
    children,
    footer,
    icon,
    alt,
    showCloseButton = true,
    size,
    badge,
}: ModalProps) {
    if (!isOpen) {
        return null
    }

    return (
        <Modal label={label} isOpen={isOpen} onClose={onClose} size={size}>
            <Styled.Modal>
                <Styled.ModalHeader>
                    <Styled.TitleContainer>
                        <Styled.LeftGroup>
                            {icon && <Icon src={icon} size={'lg'} alt={alt || ''} />}
                            {badge}
                            <Styled.ModalTitle>{title}</Styled.ModalTitle>
                        </Styled.LeftGroup>
                        <Styled.RightGroup>
                            {showCloseButton && <CloseButton onClose={onClose}></CloseButton>}
                        </Styled.RightGroup>
                    </Styled.TitleContainer>
                </Styled.ModalHeader>
                <Styled.Dialog aria-label={label}>{children}</Styled.Dialog>
                {footer && <Styled.Footer>{footer}</Styled.Footer>}
            </Styled.Modal>
        </Modal>
    )
}
